module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sideber"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_vm._v("The sale of this book without its cover is unauthorized. If you purchased this book without a cover, you should be aware that it was reported to the publisher as “unsold and destroyed.” Neither the author nor the publisher has received payment for the sale of this “stripped book.”")])]), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_c('p', {
    staticClass: "copyright"
  }, [_vm._v("This book is a work of fiction. Names, characters, places, and incidents are either products of the author’s imagination or are used fictitiously. Any resemblance to actual events or locales or persons, living or dead, is entirely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("An "), _c('em', [_vm._v("Original")]), _vm._v(" Publication "), _c('em', [_vm._v("of")]), _vm._v(" POCKET BOOKS")]), _vm._v(" "), _c('table', {
    attrs: {
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "65%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "copyright"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f004-01.jpg"
    }
  })])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "copyright"
  }, [_vm._v("POCKET PULSE, published by"), _c('br'), _vm._v("Pocket Books, a division of Simon & Schuster, Inc."), _c('br'), _vm._v("1230 Avenue of the Americas, New York, NY 10020"), _c('br'), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.simonandschuster",
      "target": "_blank"
    }
  }, [_vm._v("www.simonandschuster")])])])])])]), _vm._v(" "), _c('table', {
    attrs: {
      "cellpadding": "4",
      "cellspacing": "0",
      "width": "65%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "copyright"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f004-02.jpg"
    }
  })])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "copyright"
  }, [_vm._v("Produced by 17th Street Productions,"), _c('br'), _vm._v("an Alloy Online, Inc. company"), _c('br'), _vm._v("33 West 17th Street"), _c('br'), _vm._v(" New York, NY 10011")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Copyright © 2000 by Francine Pascal")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Cover art copyright © 2000 by 17th Street Productions,")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighta"
  }, [_vm._v("an Alloy Online, Inc. company.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighta"
  }, [_vm._v("Cover photography by St. Denis. Cover design by Mike Rivilis.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved, including the right to reproduce")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighta"
  }, [_vm._v("this book or portions thereof in any form whatsoever.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighta"
  }, [_vm._v("For information address 17th Street Productions,")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighta"
  }, [_vm._v("33 West 17th Street, New York, NY 10011, or Pocket Books,")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighta"
  }, [_vm._v("1230 Avenue of the Americas, New York, NY 10020.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN: 0-671-03949-0")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN: 978-0-671-03949-3")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("eISBN: 978-0-743-43413-3")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("First Pocket Pulse Paperback printing June 2000")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Fearless™ is a trademark of Francine Pascal.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighta"
  }, [_vm._v("POCKET PULSE and colophon are")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighta"
  }, [_vm._v("trademarks of Simon & Schuster, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Printed in the U.S.A.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8422d616","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 69
// module chunks = 0